import { connect } from 'react-redux';

import { State } from 'store/types';
import { fetchDynamicWishlist, addToDynamicWishlist } from '@nykaa/prices-revealed-shared/store/action';
import { selectCurrentSku } from 'shared/store/product/selector';
import View from './View';


const mapStateToProps = (state: State) => {
  const { priceReveal } = state;
  const { childId, sku, productType } = selectCurrentSku(state) || {};
  return {
    itemsInDynamicWishlist: priceReveal.items,
    currentSkuId: childId,
    childSku: sku,
    type: productType,
  };
};

const mapDispatchToProps = ({
  fetchDynamicWishlist,
  addToDynamicWishlist,
});

export default connect(mapStateToProps, mapDispatchToProps)(View);

